import React, { createContext, useContext } from 'react';

/* Mock data context — used by the preview screens.

   When a preview wraps its children in <MockProvider value={...}>, the
   useAccountInfo() and useFamiliesData() hooks short-circuit and return the
   mock data instead of subscribing to Firestore. Production paths get
   `value === undefined`, so the hooks fall through to their real
   implementations.

   Shape:
     {
       account: {           // overrides useAccountInfo() return value
         loading, userEmail, accountUUID, accountName,
         families, primaryFamilyID, owningFamilies,
       },
       families: {          // map of fid → family snapshot, overrides useFamiliesData
         [familyID]: {
           familyName, autoMode, hasEverSignedIn, onlinePingMs,
           screen, wifiRssiDbm, iglooLinks, isOnline,
         },
       },
       higlos: {            // map of iglooID → composed igloo snapshot,
                            // overrides useAccountHiglos
         [iglooID]: { iglooID, info, familyMemberships },
       },
     }
*/
const MockContext = createContext(null);

export function MockProvider({ value, children }) {
  return <MockContext.Provider value={value}>{children}</MockContext.Provider>;
}

export function useMock() {
  return useContext(MockContext);
}
